// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * ProjectAutoassignedUserAttributes type.
 * @typedef {object} ProjectAutoassignedUserAttributes
 * @property {string} id - Attribute value.
 * @property {string | null} projectId - Attribute value.
 * @property {string | null} userId - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by ProjectAutoassignedUserCreateAttributes.
 * @typedef {object} ProjectAutoassignedUserCreateAttributes
 * @property {ProjectAutoassignedUserAttributes["projectId"] | null} [projectId] - Permitted projectId value.
 * @property {ProjectAutoassignedUserAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Attributes accepted by ProjectAutoassignedUserUpdateAttributes.
 * @typedef {object} ProjectAutoassignedUserUpdateAttributes
 * @property {ProjectAutoassignedUserAttributes["projectId"] | null} [projectId] - Permitted projectId value.
 * @property {ProjectAutoassignedUserAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Frontend model for ProjectAutoassignedUser.
 * @augments {FrontendModelBase<ProjectAutoassignedUserAttributes, ProjectAutoassignedUserCreateAttributes, ProjectAutoassignedUserUpdateAttributes, ProjectAutoassignedUserAttributes["id"], string>}
 */
class ProjectAutoassignedUser extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "ProjectAutoassignedUser",
      attributes: [
        "id",
        "projectId",
        "userId",
        "createdAt",
        "updatedAt",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      project: {type: "belongsTo"},
      user: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      project: "Project",
      user: "User",
    }
  }

  /** @returns {ProjectAutoassignedUserAttributes["id"]} - Attribute value. */
  id() { return /** @type {ProjectAutoassignedUserAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {ProjectAutoassignedUserAttributes["id"] | null} newValue - New attribute value.
   * @returns {ProjectAutoassignedUserAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {ProjectAutoassignedUserAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {ProjectAutoassignedUserAttributes["projectId"]} - Attribute value. */
  projectId() { return /** @type {ProjectAutoassignedUserAttributes["projectId"]} */ (this.readAttribute("projectId")) }

  /**
   * @param {ProjectAutoassignedUserAttributes["projectId"] | null} newValue - New attribute value.
   * @returns {ProjectAutoassignedUserAttributes["projectId"] | null} - Assigned value.
   */
  setProjectId(newValue) { return /** @type {ProjectAutoassignedUserAttributes["projectId"] | null} */ (this.setAttribute("projectId", newValue)) }

  /** @returns {ProjectAutoassignedUserAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {ProjectAutoassignedUserAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {ProjectAutoassignedUserAttributes["userId"] | null} newValue - New attribute value.
   * @returns {ProjectAutoassignedUserAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {ProjectAutoassignedUserAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /** @returns {ProjectAutoassignedUserAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {ProjectAutoassignedUserAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {ProjectAutoassignedUserAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {ProjectAutoassignedUserAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Returns project relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<ProjectAutoassignedUser, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} - Relationship helper.
   */
  projectRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<ProjectAutoassignedUser, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} */ (this.getRelationshipByName("project")) }

  /**
   * Returns project.
   * @returns {import("./project.js").Project | null} - Loaded related model.
   */
  project() { return this.projectRelationship().loaded() }

  /**
   * Builds project.
   * @param {import("./project.js").ProjectCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./project.js").Project} - Built related model.
   */
  buildProject(attributes = {}) { return this.projectRelationship().build(attributes) }

  /**
   * Loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async loadProject() { return await this.projectRelationship().load() }

  /**
   * Returns or loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async projectOrLoad() { return await this.projectRelationship().orLoad() }

  /**
   * Sets project.
   * @param {import("./project.js").Project | null} model - Related model.
   * @returns {void}
   */
  setProject(model) { this.projectRelationship().setLoaded(model) }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<ProjectAutoassignedUser, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<ProjectAutoassignedUser, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(ProjectAutoassignedUser)

export {ProjectAutoassignedUser}

export default ProjectAutoassignedUser
